var map = {
	"./clear.png": "b520",
	"./fontFimaly/tf_din_medium-subfont.ttf": "2628",
	"./img/b2cMall/coupon.svg": "2b9d",
	"./img/b2cMall/coupon_check.svg": "9ef7",
	"./img/b2cMall/goods.svg": "edd1",
	"./img/b2cMall/goods_check.svg": "be84",
	"./img/common/DefaultAvatar.png": "1abf",
	"./img/common/bottom_allow.svg": "7777",
	"./img/common/bottom_allow_active.svg": "a06d",
	"./img/common/clean.svg": "45a4",
	"./img/common/drop-down-active.svg": "9d40",
	"./img/common/drop-down.svg": "5049",
	"./img/common/header.jpg": "d16a",
	"./img/common/log.svg": "a5b1",
	"./img/common/man.png": "edf3",
	"./img/common/no_jurisdiction.svg": "8b01",
	"./img/common/picture.svg": "62c7",
	"./img/common/search.svg": "3e08",
	"./img/common/shoot.svg": "fd47",
	"./img/common/tool.svg": "9d17",
	"./img/common/women.png": "4e7d",
	"./img/community/group_peoples.svg": "b37e",
	"./img/community/writing-fluently.svg": "6e20",
	"./img/customer-portrait/BUSINESS.svg": "3a68",
	"./img/customer-portrait/CRM.svg": "16f4",
	"./img/customer-portrait/EMAIL.svg": "9336",
	"./img/customer-portrait/MINI_PROGRAM.svg": "c4ac",
	"./img/customer-portrait/MOBILE.svg": "c55a",
	"./img/customer-portrait/OFFLINE.svg": "5fbf",
	"./img/customer-portrait/ONLINE.svg": "2d83",
	"./img/customer-portrait/OPEN.svg": "febe",
	"./img/customer-portrait/THIRD.svg": "5d32",
	"./img/customer-portrait/YOUZAN.svg": "3d97",
	"./img/customer-portrait/add.png": "1312",
	"./img/customer-portrait/addicon.svg": "0a85",
	"./img/customer-portrait/call-disabled.svg": "774b",
	"./img/customer-portrait/call.svg": "7126",
	"./img/customer-portrait/check.svg": "d813",
	"./img/customer-portrait/detail-disabled.svg": "5d3d",
	"./img/customer-portrait/detail.svg": "1464",
	"./img/customer-portrait/label-disabled.svg": "3fdd",
	"./img/customer-portrait/label.svg": "0187",
	"./img/customer-portrait/loading.svg": "8187",
	"./img/customer-portrait/log-disabled.svg": "350b",
	"./img/customer-portrait/log.svg": "4a33",
	"./img/customer-portrait/no-data.png": "13b1",
	"./img/customer-portrait/no-select.png": "21df",
	"./img/customer-portrait/no_user_data.svg": "8d6b",
	"./img/customer-portrait/selected.png": "fad6",
	"./img/customer-portrait/send-msg.png": "5435",
	"./img/customer-portrait/wechat.svg": "4ad8",
	"./img/customer-portrait/writing-fluently.svg": "8a06",
	"./img/customization/coupon.svg": "7c07",
	"./img/customization/help.svg": "c820",
	"./img/customization/hint.png": "4a09",
	"./img/customization/right_allow.svg": "5979",
	"./img/group-portrait/caret-down.svg": "fda1",
	"./img/group-portrait/down-active.svg": "ff9a",
	"./img/group-portrait/no-label.svg": "95c2",
	"./img/group-portrait/updown.svg": "ae2c",
	"./img/group-portrait/writing-fluently-background.svg": "6bb4",
	"./img/guidePage/business/businessOne.svg": "8e49",
	"./img/guidePage/business/businessThree.svg": "f12d",
	"./img/guidePage/business/businessTitle.svg": "c470",
	"./img/guidePage/business/businessTwo.svg": "dd69",
	"./img/guidePage/common/refresh.svg": "6a1c",
	"./img/guidePage/member/member-first-circle.svg": "975d",
	"./img/guidePage/member/member-first-col.svg": "1a3f",
	"./img/guidePage/member/member-second-circle.svg": "4bbc",
	"./img/guidePage/member/member-second-col.svg": "4504",
	"./img/guidePage/moments/business/businessOne.svg": "ced2",
	"./img/guidePage/moments/business/businessThree.svg": "d936",
	"./img/guidePage/moments/business/businessTitle.svg": "2de8",
	"./img/guidePage/moments/business/businessTwo.svg": "3720",
	"./img/guidePage/moments/member/memberFive.svg": "18cd",
	"./img/guidePage/moments/member/memberFour.svg": "b4ee",
	"./img/guidePage/moments/member/memberOne.svg": "aecd",
	"./img/guidePage/moments/member/memberThree.svg": "62df",
	"./img/guidePage/moments/member/memberTwo.svg": "f3fe",
	"./img/knowledge/Moments.svg": "6e6e",
	"./img/knowledge/customer.svg": "56b6",
	"./img/knowledge/customer_group.svg": "c01e",
	"./img/material-library/close.svg": "89e0",
	"./img/material-library/collect-black.svg": "93a8",
	"./img/material-library/collect-white.svg": "0194",
	"./img/material-library/collect.svg": "2c94",
	"./img/material-library/edit.svg": "5511",
	"./img/material-library/hint.svg": "bd62",
	"./img/material-library/send.svg": "b337",
	"./img/material-library/time.svg": "2789",
	"./img/menu_icon/customer_active.svg": "1f3a",
	"./img/menu_icon/customer_g_active.svg": "8dc0",
	"./img/menu_icon/customer_g_inactive.svg": "8c70",
	"./img/menu_icon/customer_inactive.svg": "9a96",
	"./img/menu_icon/home_active.svg": "6277",
	"./img/menu_icon/home_inactive.svg": "03d9",
	"./img/menu_icon/task_active.svg": "ba59",
	"./img/menu_icon/task_inactive.svg": "0195",
	"./img/nodata/label_nodata.svg": "5a6e",
	"./img/qr_check/copy.svg": "0e1c",
	"./img/qr_check/failed.svg": "f17b",
	"./img/qr_check/success.svg": "7d87",
	"./img/quickSend/LINK.svg": "ca0c",
	"./img/quickSend/LINK_2x.svg": "44dc",
	"./img/quickSend/MINIPROGRAM.svg": "90e8",
	"./img/quickSend/MINIPROGRAM_2x.svg": "7375",
	"./img/quickSend/VIDEO.svg": "096a",
	"./img/quickSend/VIDEO_2x.svg": "2ef3",
	"./img/quickSend/addition.svg": "8c37",
	"./img/quickSend/default_2x.svg": "2333",
	"./img/quickSend/delete.svg": "7aa2",
	"./img/quickSend/delete_icon.svg": "d78a",
	"./img/quickSend/edit_icon.svg": "8e9f",
	"./img/quickSend/excel.svg": "5e28",
	"./img/quickSend/excel_2x.svg": "c765",
	"./img/quickSend/hint.svg": "1888",
	"./img/quickSend/kn_nodata.svg": "1909",
	"./img/quickSend/loading.svg": "a45a",
	"./img/quickSend/material-active.svg": "fa3b",
	"./img/quickSend/material.svg": "05d0",
	"./img/quickSend/menu_move.svg": "0048",
	"./img/quickSend/pdf.svg": "c976",
	"./img/quickSend/pdf_2x.svg": "cd05c",
	"./img/quickSend/ppt.svg": "cae5",
	"./img/quickSend/ppt_2x.svg": "ce76",
	"./img/quickSend/review.svg": "959f",
	"./img/quickSend/setting.svg": "efa1",
	"./img/quickSend/share_icon.svg": "8893",
	"./img/quickSend/speech_nodata.svg": "f49e",
	"./img/quickSend/strategy-active.svg": "e6fa",
	"./img/quickSend/strategy.svg": "38c5",
	"./img/quickSend/talk_nodata.svg": "40e2",
	"./img/quickSend/task-active.svg": "ea1a",
	"./img/quickSend/task.svg": "1df5",
	"./img/quickSend/word.svg": "536e",
	"./img/quickSend/word_2x.svg": "de56",
	"./img/suggestion/applet.svg": "7d1b",
	"./img/suggestion/applet_2x.svg": "9934",
	"./img/suggestion/default_2x.svg": "d09ef",
	"./img/suggestion/edit-icon.svg": "aa0f",
	"./img/suggestion/link.svg": "9d2f",
	"./img/suggestion/link_2x.svg": "251a",
	"./img/suggestion/setting.png": "bde9",
	"./img/suggestion/share-icon.svg": "5c6a",
	"./img/suggestion/share.svg": "4ce9",
	"./img/suggestion/share_icon.svg": "7833",
	"./img/suggestion/task_nodata.svg": "a6bb",
	"./img/suggestion/video.svg": "d6ba",
	"./img/suggestion/video_2x.svg": "8ddb",
	"./img/tool/addFriends.svg": "b3f4",
	"./img/tool/clear.svg": "a555",
	"./img/tool/edit.svg": "a19e",
	"./img/tool/knowledge.svg": "2a13",
	"./img/tool/speech.svg": "8a4e",
	"./img/tool/task.svg": "bce5",
	"./img/tool/welcome.svg": "7cc6",
	"./img/welcome/delete.svg": "7a7e",
	"./img/welcome/file.svg": "168b",
	"./img/welcome/image.svg": "27ad",
	"./img/welcome/link.svg": "7dca",
	"./img/welcome/video.svg": "1490",
	"./logo.png": "cf05",
	"./style/bottom_btn.less": "1ae2",
	"./style/global.less": "788f",
	"./style/imitate_search.less": "a090",
	"./style/public.css": "cf13",
	"./style/public.less": "c128",
	"./style/reset.css": "7371",
	"./style/theme.css": "5f69",
	"./style/theme.less": "d7f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";